// extracted by mini-css-extract-plugin
export var quillEditor = "_pc-1";
export var variable = "_pc-0";